import OpenFinance from '@/components/templates/OpenFinance';

export default function OpenFinancePage() {
  return <OpenFinance />;
}
